var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditred(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14V12.1251H12.5V14H0ZM2.5 9.25844H3.27283L8.46036 4.08053L8.06733 3.68149L7.67791 3.29808L2.5 8.48561V9.25844ZM1.56252 10.1959V8.08658L8.56853 1.09018C8.65907 0.999634 8.76183 0.931129 8.87681 0.88466C8.9918 0.838181 9.11143 0.814941 9.2357 0.814941C9.35997 0.814941 9.48036 0.838181 9.59688 0.88466C9.71338 0.931129 9.8201 1.00284 9.91706 1.0998L10.6683 1.86061C10.7652 1.95115 10.8353 2.05484 10.8786 2.17168C10.9218 2.28852 10.9435 2.40925 10.9435 2.53388C10.9435 2.65072 10.9215 2.76695 10.8777 2.88257C10.8338 2.99818 10.764 3.10383 10.6683 3.19952L3.67186 10.1959H1.56252ZM8.46036 4.08053L8.06733 3.68149L7.67791 3.29808L8.46036 4.08053Z",
    fill: "#FF1212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditred);
export default __webpack_public_path__ + "static/media/editred.5d05030c29e26916e56f45fba903382e.svg";
export { ForwardRef as ReactComponent };